var _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbTextLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "master-artboard",
    viewBox: "25 20 790 80",
    x: "0px",
    y: "0px",
    width: 600,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-5.646160161631998e-7, 1.4355478286743166, -1.4355478286743166, -5.646160161631998e-7, 896.6483430995531, -416.3243357331213)"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.2084,314.3367)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 12.204,-0.03 18.731,-6.547 18.731,-18.717 0,-11.949 -6.726,-18.656 -18.608,-18.63 l -21.62,0.071 v 13.41 l 20.929,-0.033 c 5.803,-0.023 8.366,1.48 8.355,5.1 0.011,3.61 -2.306,5.358 -8.949,5.377 l -20.338,0.056 0.003,13.43 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.6912,121.905)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 29.429,-0.082 V -13.661 L 0,-13.568 l 0.004,-11.351 -10,0.033 0.012,36.256 9.995,-0.026 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.1198,164.7416)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -7.227,-2.257 V -14.995 L 0,-17.409 0.011,-30.92 -39.421,-17.095 -39.425,0.056 0,13.515 Z m -30.431,-8.647 13.504,-3.374 0.008,6.752 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.0781,357.8047)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -10.231,-4.043 c 1.88,-2.395 3.583,-4.816 3.572,-8.762 0,-5.321 -4.573,-8.863 -10.152,-8.841 -5.661,0.007 -10.388,3.142 -10.399,8.687 -0.015,3.49 1.816,6.536 3.845,8.965 l -9.999,4.024 c -2.358,-4.477 -3.781,-8.949 -3.781,-15.107 -0.019,-11.415 8.156,-20.077 20.218,-20.114 C -4.196,-35.232 3.86,-26.844 3.86,-14.819 3.86,-8.198 2.264,-3.546 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.1291,388.2773)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -14.356,-8.441 0.022,-8.49 0,-21.665 l -39.421,0.12 0.004,13.171 14.442,-0.045 -14.431,7.993 V 14.277 L -19.98,1.861 0.011,15.765 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.9276,74.261)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.011,8.546 -3.191,17.401 -13.265,17.424 -9.099,0.041 -11.58,-7.358 -12.895,-13.108 -0.96,-4.338 -1.439,-6.438 -3.262,-6.42 -2.399,0 -2.597,2.941 -2.597,4.495 0.015,3.909 1.682,7.548 3.666,10.683 l -8.983,3.535 c -2.063,-4.596 -3.692,-10.152 -3.692,-15.365 0,-8.867 4.477,-15.813 13.486,-15.824 7.387,-0.034 10.234,5.309 11.766,11.232 1.054,4.077 1.386,6.696 3.49,6.688 2.119,-0.011 2.75,-2.006 2.743,-3.96 0.007,-4.32 -1.947,-8.408 -4.241,-10.934 l 8.71,-4.278 C -1.954,-11.251 0,-5.653 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.9396,423.9867)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,8.546 -3.173,17.409 -13.258,17.439 -9.102,0.018 -11.59,-7.361 -12.88,-13.12 -0.975,-4.349 -1.442,-6.427 -3.262,-6.415 -2.417,0.015 -2.6,2.925 -2.611,4.495 0.011,3.905 1.681,7.548 3.691,10.672 l -8.986,3.561 c -2.067,-4.608 -3.703,-10.183 -3.722,-15.369 0.019,-8.874 4.473,-15.821 13.489,-15.839 7.399,-0.027 10.257,5.328 11.786,11.224 1.053,4.081 1.359,6.707 3.493,6.692 2.111,0 2.735,-2.002 2.735,-3.945 0,-4.309 -1.958,-8.4 -4.248,-10.949 l 8.714,-4.263 C -1.958,-11.247 0,-5.627 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.2843,207.9601)",
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 2.586,-0.015 4.088,-1.573 4.088,-4.144 l -0.012,-4.641 -8.231,0.026 v 4.69 c 0.007,2.477 1.33,4.08 4.032,4.069 z M 11.113,6.079 C 9.356,10.69 4.476,13.209 -0.056,13.212 -9.353,13.25 -13.579,7.178 -13.571,-1.454 l -0.015,-20.345 39.421,-0.101 v 13.052 l -11.688,0.033 v 3.3 l 11.688,6.74 v 14.106 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.9289,254.3232)",
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 2.302,0.007 3.662,-1.618 3.651,-4.275 l 0.011,-4.779 -7.391,0.023 V -4.2 c 0,2.552 1.188,4.207 3.62,4.219 z m -18.664,-8.99 0.003,4.726 c -0.022,2.489 1.114,4.122 3.423,4.122 l 0.105,-0.011 c 2.193,0 3.471,-1.577 3.475,-4.185 l 0.011,-4.675 z M -7.925,5.496 c -1.103,4.899 -3.991,7.317 -8.793,7.332 -6.718,0.033 -10.499,-4.772 -10.499,-13.243 l 0.007,-21.478 39.432,-0.093 V -1.364 C 12.192,8.594 8.527,13.567 1.087,13.579 -4.051,13.586 -7.511,10.492 -7.925,5.496"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(239.9966,454.0739)",
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -1.502 h -10.728 v 2.32 l 8.127,2.739 -8.127,2.653 V 8.519 H 0 V 7.017 H -8.953 V 6.976 L 0,3.994 V 3.027 L -8.953,0.045 V 0 Z M -9.323,-2.825 V -5.646 H 0 v -1.502 h -9.323 v -2.784 h -1.405 v 7.107 z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbTextLogo);
export default __webpack_public_path__ + "static/media/sb-text-logo.a00ed997535a23d21fa37c9f6cdf8d3d.svg";
export { ForwardRef as ReactComponent };